import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Element } from 'react-scroll';
import { propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import InputError from '../../../../../../Ui/Common/InputError';
import PlainDatePicker from '../../../../../../Ui/Common/PlainDatePicker';
const DateInput = (props) => {
    const { className, input, meta, title } = props;
    return (_jsx(Element, Object.assign({ className: `field ${className}`, name: `${input.name}_view` }, { children: _jsxs("label", { children: [_jsxs("div", Object.assign({ className: 'label' }, { children: [_jsx("span", { children: title }), _jsx("span", Object.assign({ className: 'req' }, { children: "\u5FC5\u9808" }))] })), _jsxs("div", { children: [_jsx("div", { children: _jsx(PlainDatePicker, { className: '', input: input, meta: meta }) }), _jsx(InputError, { meta: meta })] })] }) })));
};
DateInput.propTypes = {
    className: propStr().isRequired,
    input: propShape().isRequired,
    meta: propShape().isRequired,
    title: propStr().isRequired,
};
export default DateInput;
